import { startOfDay, endOfDay } from 'date-fns';
import { axiosInstance } from '../common/api';

export const getAllReport = (
  selectedClient,
  selectedProject,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, {
        selectedClient,
        selectedProject,
        selectedEmployee,
        selectedTaskNote,
        startDate: startOfDay(dataObj.selection.startDate),
        endDate: endOfDay(dataObj.selection.endDate),
        selectedTaskTypes,
        selectedBillableTypes,
        timeZone,
      })
      .then((response) => resolve(response?.data?.data))
      .catch((err) => reject(err));
  });
};

// ..............................new report Services.......................
const generateReport = (url, params) =>
  new Promise((resolve, reject) => {
    axiosInstance
      .post(url, params)
      .then((response) => resolve(response?.data?.data))
      .catch((err) => reject(err));
  });

export const getClientReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/client`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getEmployeeReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/user`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getTaskNoteReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/task`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getTaskTypeReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/task-type`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getDayWiseHourReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/day-wise-hour`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getProjectReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/project`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getTimeSheetReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/timesheet`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getPlannedVsActualReport = (
  selectedClient,
  selectedProject,
  selectedProjectStatus,
  selectedTaskStatus,
  selectedEmployee,
  selectedTaskNote,
  dataObj,
  selectedTaskTypes,
  selectedBillableTypes,
  timeZone
) => {
  const url = `/report/planned-vs-actual`;
  const params = {
    selectedClient,
    selectedProject,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedEmployee,
    selectedTaskNote,
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),
    selectedTaskTypes,
    selectedBillableTypes,
    timeZone,
  };
  return generateReport(url, params);
};

export const getProjectConsumedHours = (dataObj) => {
  const url = `/report/project-consumed-hours`;
  const params = {
    selectedClient: [],
    selectedEmployee: [],
    selectedProject: [],
    selectedProjectStatus: [],
    selectedTaskStatusList: [],
    selectedTaskNote: '',
    selectedTaskTypes: [],
    startDate: startOfDay(dataObj.selection.startDate),
    endDate: endOfDay(dataObj.selection.endDate),

    // timeZone,
  };
  return generateReport(url, params);
};
